<script setup lang="ts">
const route = useRoute()

const slug = computed(() => route.params.slug?.toString() || '')
const entry = computed(() => route.params.entry?.toString() || '')
const page = computed(() => route.params.code?.toString() || '1')

const { data: blogs } = await useAsyncData(`blogs-${route.path}`, () =>
  $fetch(`/intl-api/blogs`, {
    params: {
      search: route.query.search,
      category: entry.value,
      page: parseInt(page.value)
    }
  })
)

if (!blogs.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Blog not found'
  })
}

useDefaultMeta({
  title:
    blogs.value.category?.meta_title ||
    blogs.value.category?.name ||
    'Blog KiriminAja',
  description:
    blogs.value.category?.meta_desc ||
    'Temukan informasi lengkap tentang bisnis, e-commerce &amp; tips keuangan di sini! Kirim paket COD multi ekspedisi | Blog KiriminAja',
  robots: 'noindex, follow'
})
</script>

<template>
  <BlogSectionCategory />
  <section class="py-6 lg:py-10">
    <UiContainer>
      <h1 class="text-xl font-display lg:text-3xl font-bold">
        Kumpulan Informasi Lengkap Seputar
        <span class="text-primary">{{ blogs?.category?.name ?? 'Blog' }}</span>
      </h1>
    </UiContainer>
    <BlogSectionBase
      :search="route.query.search?.toString()"
      :blogs="blogs?.items"
      :meta="blogs?.meta"
      :path="`/blog/${slug}/${entry}`"
      :page="parseInt(page)"
    />
  </section>
  <CtaSection />
</template>
